import { mutate } from "swr"

import useResource from "./useResource"
import { isObjectWithProperty } from "web/services/helpers"

export default function useSetting({
  scope,
  setting,
  defaultValue,
  validator,
}) {
  const key = `/settings/${scope}/${setting}`
  const [settingResource, { update: updateResource, destroy }] = useResource({
    key: key,
    localMutate: true,
  })

  async function update(value) {
    if (value === null || value === undefined) {
      await destroy()

      // mutate after destroy was removed from useResource,
      // but is needed here, otherwise there will be no
      // re-render in consumer after setting is removed
      mutate(key)
    } else {
      return updateResource({ value })
    }
  }

  const hasSetting = isObjectWithProperty(settingResource, "value")
  const hasValidator = typeof validator === "function"

  if (!hasSetting || (hasValidator && !validator(settingResource.value))) {
    return [defaultValue, update]
  }

  return [settingResource.value, update]
}
